<template>
<div>
  <b-row class="mt-2">
     <b-col md="2">
        <b-list-group v-for="menu in listAccounts" :key="menu.id">
          <b-list-group-item @click="getInfo(menu.id)" button>{{ menu.name }}
          </b-list-group-item>
        </b-list-group>
      </b-col>

     <b-col md="4" v-if="selectedMenu.journalAccountName">
       <!-- <b-row >
         <b-col md="2">
           <label for="" class="labels">code :</label>
         </b-col>
         <b-col md="2">
           <p class="text-bold">{{ selectedMenu.journalAccountCode}}</p>
         </b-col>
       </b-row>
       <b-row>
         <b-col md="2">
           <label for="" class="labels">name :</label>
         </b-col>
         <b-col md="4">
           <p class="text-bold">{{ selectedMenu.journalAccountName}}</p>
         </b-col>
       </b-row> -->
       
       <b-row>
         <b-col md="6">
          <b-list-group v-for="child in selectedMenu.journalAccountChild" :key="child.uuid">
           <b-list-group-item @click="getInfoChild(child.uuid)" button>{{child.journalAccountCode + ' - '}} {{ child.journalAccountType + ' - '  }} {{ child.journalAccountName }}</b-list-group-item>
          </b-list-group>
          <div class="mt-3" v-if="show1">
            <!-- <b-row >
              <b-col md="6">
                <label for="" class="labels">code :</label>
              </b-col>
              <b-col md="6">
                <p class="text-bold">{{ selectedChild.journalAccountCode}}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <label for="" class="labels">name :</label>
              </b-col>
              <b-col md="6">
                <p class="text-bold">{{ selectedChild.journalAccountName}}</p>
              </b-col>
            </b-row>
            <b-row>
            <b-col md="6">
              <label for="" class="labels">Balance:</label>
            </b-col>
            <b-col md="6">
              <p class="text-bold">{{ formatPrice(selectedChild.journalAccountBalance)}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <label for="" class="labels">Balance Total Now:</label>
            </b-col>
            <b-col md="6">
              <p class="text-bold">{{ formatPrice(selectedChild.journalAccountBalanceNow)}}</p>
            </b-col>
          </b-row> -->
        </div>
         </b-col>
         <b-col md="6" class="mt-5" v-if="show1">
           <b-list-group v-for="r in selectedChild.journalAccountChild" :key="r.uuid">
            <b-list-group-item @click="getInfoChildOfChild(r.uuid)" button>{{r.journalAccountCode + ' - '}} {{ r.journalAccountType + ' - '  }} {{ r.journalAccountName }}</b-list-group-item>
           </b-list-group>
         </b-col>
       </b-row>
     </b-col>
     <b-col md="4" v-if="show">
       <b-row>
         <b-col md="6" class="mt-5" v-if="show1"> 
           <b-list-group v-for="r in selectedMore.journalAccountChild" :key="r.uuid">
            <b-list-group-item button>{{r.journalAccountCode + ' - '}} {{ r.journalAccountType + ' - '  }} {{ r.journalAccountName }}</b-list-group-item>
           </b-list-group>
         </b-col>
       </b-row>
       <!-- <table class="w-100">
          <thead>
            <tr>
              <th>Account</th>
              <th class="text-center">Initial Balance</th>
              <th class="text-center">Balance Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ detail.journalAccountCode + ' - ' + detail.journalAccountType + ' - ' + detail.journalAccountName }}</td>
              <td class="text-center"> {{ formatPrice(detail.journalAccountBalance) }}</td>
              <td class="text-center"> {{ formatPrice(detail.journalAccountBalanceNow) }} </td>
            </tr>
          </tbody>
       </table> -->
     </b-col>
    
  </b-row>
         
</div>
</template>

<script>
export default {
  components: {
  },
  props: {
    // data: {
    //   type: Array,
    //   required: true,
    // },
    // nodeKeyProp: {
    //   type: String,
    //   required: true
    // },
    // nodeChildrenProp: {
    //   type: String,
    //   required: true
    // }
  },

  data() {
    return {
      show: false,
      show1: true,
      selectedNode: '',
      listAccounts: [],
      selectedMenu: [],
      selectedChild: [],
      selectedMore: [],
      selectedChildDetail: [],
      columns: [
        {
          key: 'journalAccountName',
          label: 'Name'
        },
        {
          key: 'journalAccountCode',
          label: 'Code'
        }
      ],
      detail: {
        journalAccountName: '',
        journalAccountCode: '',
        journalAccountType: '',
        journalAccountChild: [],
        journalAccountBalance: 0,
        journalAccountBalanceNow: 0
      }
      
    };
  },

  mounted() {
    this.getAccountList();
  },

  methods: {
    getAccountList() {
      this.$http
        .get(window.AppConfig.apiUrl + 'journal-account?journalAccountType=H')
        .then((response) => {
          this.listAccounts = response.data._embedded.journal_account.map((listAccount) => ({
            id: listAccount.uuid,
            name:
              listAccount.journalAccountCode +
              ' - ' +
              listAccount.journalAccountType +
              ' - ' +
              listAccount.journalAccountName,
          }));
        });
    },

    getInfo(menu){
      this.show = false
      this.show1 = false
      this.$http.get(window.AppConfig.apiUrl + 'journal-account' + '/' + menu).then(response => {
        this.selectedMenu = response.data
      })
    },

     getInfoChild(child){
       this.show = false
       this.show1 = true
      this.$http.get(window.AppConfig.apiUrl + 'journal-account' + '/' + child).then(response => {
        this.selectedChild = response.data
      })
    },

    getInfoChildOfChild(child) {
      this.$http.get(window.AppConfig.apiUrl + 'journal-account' + '/' + child).then(response => {
        this.selectedMore = response.data
      //  this.detail.journalAccountName = response.data.journalAccountName,
      //  this.detail.journalAccountCode = response.data.journalAccountCode,
      //  this.detail.journalAccountType = response.data.journalAccountType,
      //  this.detail.journalAccountChild = response.data.journalAccountChild,
      //  this.detail.journalAccountBalance = response.data.journalAccountBalance,
      //  this.detail.journalAccountBalanceNow = response.data.journalAccountBalanceNow
      })
      this.show = true
    },

    getMoreChild(more){
      this.$http.get(window.AppConfig.apiUrl + 'journal-account' + '/' + more).then(response => {
        this.$store.dispatch("notification/error", "yeayy")
      })
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>
